module.exports = function (property) {
  return `${property.property.municipality_name}`;
};
